import React from "react";
import { MemberIcon } from "../../../constants/MemberIcon";
import UserProfile from "../common/userProfile";

const AddResources = (props) => {
  return (
    <div>
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex mt-2">
              {props?.teamMembers?.length > 0 &&
                props.teamMembers.map((item, index) => (
                  <>
                    <span
                      key={item.id}
                      className="c-pill c-pill--success d-flex changeRequest_badge ms-1"
                      style={{ backgroundColor: "#e6ffe6" }}
                    >
                      <UserProfile user={item} avatarClassName='me-2' profileClassName='me-2' profileStyle ={{height: '30px', width: '30px', fontSize: '15px'}} tooltip={true}/>
                      {item.name}
                    </span>
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddResources;
